export default __webpack_public_path__ + "static/media/NewLook.656b7e98.png";